/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ClientRouteImport } from './routes/_client'
import { Route as StaffRouteImport } from './routes/_staff'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ClientIndexRouteImport } from './routes/_client/index'
import { Route as ClientAssistantAccessRouteImport } from './routes/_client/assistant-access'
import { Route as ClientOrganizationRouteImport } from './routes/_client/organization'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as RSecretRouteImport } from './routes/r.$secret'
import { Route as ClientProjectsProjectIdRouteImport } from './routes/_client/projects.$projectId'
import { Route as StaffStaffIndexRouteImport } from './routes/_staff/staff/index'
import { Route as StaffStaffAuditRouteImport } from './routes/_staff/staff/audit'
import { Route as StaffStaffOpsRouteImport } from './routes/_staff/staff/ops'
import { Route as StaffStaffSearchRouteImport } from './routes/_staff/staff/search'
import { Route as StaffStaffSlackRouteImport } from './routes/_staff/staff/slack'
import { Route as ResetPasswordUidTokenRouteImport } from './routes/reset-password_.$uid.$token'
import { Route as StaffStaffAnalysesAnalysisIdRouteImport } from './routes/_staff/staff/analyses/$analysisId'
import { Route as StaffStaffAnalysisTypesIndexRouteImport } from './routes/_staff/staff/analysis-types/index'
import { Route as StaffStaffAnalysisTypesKeyRouteImport } from './routes/_staff/staff/analysis-types/$key'
import { Route as StaffStaffMissionsIndexRouteImport } from './routes/_staff/staff/missions/index'
import { Route as StaffStaffMissionsMissionIdRouteImport } from './routes/_staff/staff/missions/$missionId'
import { Route as StaffStaffMissionsNewRouteImport } from './routes/_staff/staff/missions/new'
import { Route as StaffStaffObjectsObjectIdRouteImport } from './routes/_staff/staff/objects/$objectId'
import { Route as StaffStaffOrganizationsIndexRouteImport } from './routes/_staff/staff/organizations/index'
import { Route as StaffStaffOrganizationsOrgIdRouteImport } from './routes/_staff/staff/organizations/$orgId'
import { Route as StaffStaffProjectsIndexRouteImport } from './routes/_staff/staff/projects/index'
import { Route as StaffStaffProjectsProjectIdRouteImport } from './routes/_staff/staff/projects/$projectId'
import { Route as StaffStaffReportsReportIdRouteImport } from './routes/_staff/staff/reports/$reportId'
import { Route as StaffStaffRunTypesIndexRouteImport } from './routes/_staff/staff/run-types/index'
import { Route as StaffStaffRunsIndexRouteImport } from './routes/_staff/staff/runs/index'
import { Route as StaffStaffRunsRunIdRouteImport } from './routes/_staff/staff/runs/$runId'
import { Route as ClientProjectsProjectIdAnalysesAnalysisIdRouteImport } from './routes/_client/projects_.$projectId.analyses.$analysisId'
import { Route as ClientProjectsProjectIdReportsReportIdRouteImport } from './routes/_client/projects_.$projectId.reports.$reportId'
import { Route as ClientProjectsProjectIdUploadObjectIdRouteImport } from './routes/_client/projects_.$projectId.upload.$objectId'
import { Route as StaffStaffProjectsProjectIdBoundaryRouteImport } from './routes/_staff/staff/projects_.$projectId.boundary'
import { Route as StaffStaffProjectsProjectIdBoundaryObjectIdRouteImport } from './routes/_staff/staff/projects_.$projectId.boundary_.$objectId'

const ClientRoute = ClientRouteImport.update({
  id: '/_client',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRoute = StaffRouteImport.update({
  id: '/_staff',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientIndexRoute = ClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientAssistantAccessRoute = ClientAssistantAccessRouteImport.update({
  id: '/assistant-access',
  path: '/assistant-access',
  getParentRoute: () => ClientRoute,
} as any)
const ClientOrganizationRoute = ClientOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => ClientRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const RSecretRoute = RSecretRouteImport.update({
  id: '/r/$secret',
  path: '/r/$secret',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientProjectsProjectIdRoute = ClientProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => ClientRoute,
} as any)
const StaffStaffIndexRoute = StaffStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffAuditRoute = StaffStaffAuditRouteImport.update({
  id: '/staff/audit',
  path: '/staff/audit',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffOpsRoute = StaffStaffOpsRouteImport.update({
  id: '/staff/ops',
  path: '/staff/ops',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffSearchRoute = StaffStaffSearchRouteImport.update({
  id: '/staff/search',
  path: '/staff/search',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffSlackRoute = StaffStaffSlackRouteImport.update({
  id: '/staff/slack',
  path: '/staff/slack',
  getParentRoute: () => StaffRoute,
} as any)
const ResetPasswordUidTokenRoute = ResetPasswordUidTokenRouteImport.update({
  id: '/reset-password_/$uid/$token',
  path: '/reset-password/$uid/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffStaffAnalysesAnalysisIdRoute =
  StaffStaffAnalysesAnalysisIdRouteImport.update({
    id: '/staff/analyses/$analysisId',
    path: '/staff/analyses/$analysisId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffAnalysisTypesIndexRoute =
  StaffStaffAnalysisTypesIndexRouteImport.update({
    id: '/staff/analysis-types/',
    path: '/staff/analysis-types/',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffAnalysisTypesKeyRoute =
  StaffStaffAnalysisTypesKeyRouteImport.update({
    id: '/staff/analysis-types/$key',
    path: '/staff/analysis-types/$key',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffMissionsIndexRoute = StaffStaffMissionsIndexRouteImport.update({
  id: '/staff/missions/',
  path: '/staff/missions/',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffMissionsMissionIdRoute =
  StaffStaffMissionsMissionIdRouteImport.update({
    id: '/staff/missions/$missionId',
    path: '/staff/missions/$missionId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffMissionsNewRoute = StaffStaffMissionsNewRouteImport.update({
  id: '/staff/missions/new',
  path: '/staff/missions/new',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffObjectsObjectIdRoute =
  StaffStaffObjectsObjectIdRouteImport.update({
    id: '/staff/objects/$objectId',
    path: '/staff/objects/$objectId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffOrganizationsIndexRoute =
  StaffStaffOrganizationsIndexRouteImport.update({
    id: '/staff/organizations/',
    path: '/staff/organizations/',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffOrganizationsOrgIdRoute =
  StaffStaffOrganizationsOrgIdRouteImport.update({
    id: '/staff/organizations/$orgId',
    path: '/staff/organizations/$orgId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffProjectsIndexRoute = StaffStaffProjectsIndexRouteImport.update({
  id: '/staff/projects/',
  path: '/staff/projects/',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffProjectsProjectIdRoute =
  StaffStaffProjectsProjectIdRouteImport.update({
    id: '/staff/projects/$projectId',
    path: '/staff/projects/$projectId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffReportsReportIdRoute =
  StaffStaffReportsReportIdRouteImport.update({
    id: '/staff/reports/$reportId',
    path: '/staff/reports/$reportId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffRunTypesIndexRoute = StaffStaffRunTypesIndexRouteImport.update({
  id: '/staff/run-types/',
  path: '/staff/run-types/',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffRunsIndexRoute = StaffStaffRunsIndexRouteImport.update({
  id: '/staff/runs/',
  path: '/staff/runs/',
  getParentRoute: () => StaffRoute,
} as any)
const StaffStaffRunsRunIdRoute = StaffStaffRunsRunIdRouteImport.update({
  id: '/staff/runs/$runId',
  path: '/staff/runs/$runId',
  getParentRoute: () => StaffRoute,
} as any)
const ClientProjectsProjectIdAnalysesAnalysisIdRoute =
  ClientProjectsProjectIdAnalysesAnalysisIdRouteImport.update({
    id: '/projects_/$projectId/analyses/$analysisId',
    path: '/projects/$projectId/analyses/$analysisId',
    getParentRoute: () => ClientRoute,
  } as any)
const ClientProjectsProjectIdReportsReportIdRoute =
  ClientProjectsProjectIdReportsReportIdRouteImport.update({
    id: '/projects_/$projectId/reports/$reportId',
    path: '/projects/$projectId/reports/$reportId',
    getParentRoute: () => ClientRoute,
  } as any)
const ClientProjectsProjectIdUploadObjectIdRoute =
  ClientProjectsProjectIdUploadObjectIdRouteImport.update({
    id: '/projects_/$projectId/upload/$objectId',
    path: '/projects/$projectId/upload/$objectId',
    getParentRoute: () => ClientRoute,
  } as any)
const StaffStaffProjectsProjectIdBoundaryRoute =
  StaffStaffProjectsProjectIdBoundaryRouteImport.update({
    id: '/staff/projects_/$projectId/boundary',
    path: '/staff/projects/$projectId/boundary',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffStaffProjectsProjectIdBoundaryObjectIdRoute =
  StaffStaffProjectsProjectIdBoundaryObjectIdRouteImport.update({
    id: '/staff/projects_/$projectId/boundary_/$objectId',
    path: '/staff/projects/$projectId/boundary/$objectId',
    getParentRoute: () => StaffRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ClientIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/assistant-access': typeof ClientAssistantAccessRoute
  '/organization': typeof ClientOrganizationRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/r/$secret': typeof RSecretRoute
  '/projects/$projectId': typeof ClientProjectsProjectIdRoute
  '/staff/audit': typeof StaffStaffAuditRoute
  '/staff/ops': typeof StaffStaffOpsRoute
  '/staff/search': typeof StaffStaffSearchRoute
  '/staff/slack': typeof StaffStaffSlackRoute
  '/reset-password/$uid/$token': typeof ResetPasswordUidTokenRoute
  '/staff/': typeof StaffStaffIndexRoute
  '/staff/analyses/$analysisId': typeof StaffStaffAnalysesAnalysisIdRoute
  '/staff/analysis-types/$key': typeof StaffStaffAnalysisTypesKeyRoute
  '/staff/missions/$missionId': typeof StaffStaffMissionsMissionIdRoute
  '/staff/missions/new': typeof StaffStaffMissionsNewRoute
  '/staff/objects/$objectId': typeof StaffStaffObjectsObjectIdRoute
  '/staff/organizations/$orgId': typeof StaffStaffOrganizationsOrgIdRoute
  '/staff/projects/$projectId': typeof StaffStaffProjectsProjectIdRoute
  '/staff/reports/$reportId': typeof StaffStaffReportsReportIdRoute
  '/staff/runs/$runId': typeof StaffStaffRunsRunIdRoute
  '/staff/analysis-types/': typeof StaffStaffAnalysisTypesIndexRoute
  '/staff/missions/': typeof StaffStaffMissionsIndexRoute
  '/staff/organizations/': typeof StaffStaffOrganizationsIndexRoute
  '/staff/projects/': typeof StaffStaffProjectsIndexRoute
  '/staff/run-types/': typeof StaffStaffRunTypesIndexRoute
  '/staff/runs/': typeof StaffStaffRunsIndexRoute
  '/projects/$projectId/analyses/$analysisId': typeof ClientProjectsProjectIdAnalysesAnalysisIdRoute
  '/projects/$projectId/reports/$reportId': typeof ClientProjectsProjectIdReportsReportIdRoute
  '/projects/$projectId/upload/$objectId': typeof ClientProjectsProjectIdUploadObjectIdRoute
  '/staff/projects/$projectId/boundary': typeof StaffStaffProjectsProjectIdBoundaryRoute
  '/staff/projects/$projectId/boundary/$objectId': typeof StaffStaffProjectsProjectIdBoundaryObjectIdRoute
}
export interface FileRoutesByTo {
  '/': typeof ClientIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/assistant-access': typeof ClientAssistantAccessRoute
  '/organization': typeof ClientOrganizationRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/r/$secret': typeof RSecretRoute
  '/projects/$projectId': typeof ClientProjectsProjectIdRoute
  '/staff/audit': typeof StaffStaffAuditRoute
  '/staff/ops': typeof StaffStaffOpsRoute
  '/staff/search': typeof StaffStaffSearchRoute
  '/staff/slack': typeof StaffStaffSlackRoute
  '/reset-password/$uid/$token': typeof ResetPasswordUidTokenRoute
  '/staff': typeof StaffStaffIndexRoute
  '/staff/analyses/$analysisId': typeof StaffStaffAnalysesAnalysisIdRoute
  '/staff/analysis-types/$key': typeof StaffStaffAnalysisTypesKeyRoute
  '/staff/missions/$missionId': typeof StaffStaffMissionsMissionIdRoute
  '/staff/missions/new': typeof StaffStaffMissionsNewRoute
  '/staff/objects/$objectId': typeof StaffStaffObjectsObjectIdRoute
  '/staff/organizations/$orgId': typeof StaffStaffOrganizationsOrgIdRoute
  '/staff/projects/$projectId': typeof StaffStaffProjectsProjectIdRoute
  '/staff/reports/$reportId': typeof StaffStaffReportsReportIdRoute
  '/staff/runs/$runId': typeof StaffStaffRunsRunIdRoute
  '/staff/analysis-types': typeof StaffStaffAnalysisTypesIndexRoute
  '/staff/missions': typeof StaffStaffMissionsIndexRoute
  '/staff/organizations': typeof StaffStaffOrganizationsIndexRoute
  '/staff/projects': typeof StaffStaffProjectsIndexRoute
  '/staff/run-types': typeof StaffStaffRunTypesIndexRoute
  '/staff/runs': typeof StaffStaffRunsIndexRoute
  '/projects/$projectId/analyses/$analysisId': typeof ClientProjectsProjectIdAnalysesAnalysisIdRoute
  '/projects/$projectId/reports/$reportId': typeof ClientProjectsProjectIdReportsReportIdRoute
  '/projects/$projectId/upload/$objectId': typeof ClientProjectsProjectIdUploadObjectIdRoute
  '/staff/projects/$projectId/boundary': typeof StaffStaffProjectsProjectIdBoundaryRoute
  '/staff/projects/$projectId/boundary/$objectId': typeof StaffStaffProjectsProjectIdBoundaryObjectIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_client': typeof ClientRouteWithChildren
  '/_staff': typeof StaffRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_client/assistant-access': typeof ClientAssistantAccessRoute
  '/_client/organization': typeof ClientOrganizationRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/r/$secret': typeof RSecretRoute
  '/_client/': typeof ClientIndexRoute
  '/_client/projects/$projectId': typeof ClientProjectsProjectIdRoute
  '/_staff/staff/audit': typeof StaffStaffAuditRoute
  '/_staff/staff/ops': typeof StaffStaffOpsRoute
  '/_staff/staff/search': typeof StaffStaffSearchRoute
  '/_staff/staff/slack': typeof StaffStaffSlackRoute
  '/reset-password_/$uid/$token': typeof ResetPasswordUidTokenRoute
  '/_staff/staff/': typeof StaffStaffIndexRoute
  '/_staff/staff/analyses/$analysisId': typeof StaffStaffAnalysesAnalysisIdRoute
  '/_staff/staff/analysis-types/$key': typeof StaffStaffAnalysisTypesKeyRoute
  '/_staff/staff/missions/$missionId': typeof StaffStaffMissionsMissionIdRoute
  '/_staff/staff/missions/new': typeof StaffStaffMissionsNewRoute
  '/_staff/staff/objects/$objectId': typeof StaffStaffObjectsObjectIdRoute
  '/_staff/staff/organizations/$orgId': typeof StaffStaffOrganizationsOrgIdRoute
  '/_staff/staff/projects/$projectId': typeof StaffStaffProjectsProjectIdRoute
  '/_staff/staff/reports/$reportId': typeof StaffStaffReportsReportIdRoute
  '/_staff/staff/runs/$runId': typeof StaffStaffRunsRunIdRoute
  '/_staff/staff/analysis-types/': typeof StaffStaffAnalysisTypesIndexRoute
  '/_staff/staff/missions/': typeof StaffStaffMissionsIndexRoute
  '/_staff/staff/organizations/': typeof StaffStaffOrganizationsIndexRoute
  '/_staff/staff/projects/': typeof StaffStaffProjectsIndexRoute
  '/_staff/staff/run-types/': typeof StaffStaffRunTypesIndexRoute
  '/_staff/staff/runs/': typeof StaffStaffRunsIndexRoute
  '/_client/projects_/$projectId/analyses/$analysisId': typeof ClientProjectsProjectIdAnalysesAnalysisIdRoute
  '/_client/projects_/$projectId/reports/$reportId': typeof ClientProjectsProjectIdReportsReportIdRoute
  '/_client/projects_/$projectId/upload/$objectId': typeof ClientProjectsProjectIdUploadObjectIdRoute
  '/_staff/staff/projects_/$projectId/boundary': typeof StaffStaffProjectsProjectIdBoundaryRoute
  '/_staff/staff/projects_/$projectId/boundary_/$objectId': typeof StaffStaffProjectsProjectIdBoundaryObjectIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/assistant-access'
    | '/organization'
    | '/oauth/consent'
    | '/r/$secret'
    | '/projects/$projectId'
    | '/staff/audit'
    | '/staff/ops'
    | '/staff/search'
    | '/staff/slack'
    | '/reset-password/$uid/$token'
    | '/staff/'
    | '/staff/analyses/$analysisId'
    | '/staff/analysis-types/$key'
    | '/staff/missions/$missionId'
    | '/staff/missions/new'
    | '/staff/objects/$objectId'
    | '/staff/organizations/$orgId'
    | '/staff/projects/$projectId'
    | '/staff/reports/$reportId'
    | '/staff/runs/$runId'
    | '/staff/analysis-types/'
    | '/staff/missions/'
    | '/staff/organizations/'
    | '/staff/projects/'
    | '/staff/run-types/'
    | '/staff/runs/'
    | '/projects/$projectId/analyses/$analysisId'
    | '/projects/$projectId/reports/$reportId'
    | '/projects/$projectId/upload/$objectId'
    | '/staff/projects/$projectId/boundary'
    | '/staff/projects/$projectId/boundary/$objectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/reset-password'
    | '/assistant-access'
    | '/organization'
    | '/oauth/consent'
    | '/r/$secret'
    | '/projects/$projectId'
    | '/staff/audit'
    | '/staff/ops'
    | '/staff/search'
    | '/staff/slack'
    | '/reset-password/$uid/$token'
    | '/staff'
    | '/staff/analyses/$analysisId'
    | '/staff/analysis-types/$key'
    | '/staff/missions/$missionId'
    | '/staff/missions/new'
    | '/staff/objects/$objectId'
    | '/staff/organizations/$orgId'
    | '/staff/projects/$projectId'
    | '/staff/reports/$reportId'
    | '/staff/runs/$runId'
    | '/staff/analysis-types'
    | '/staff/missions'
    | '/staff/organizations'
    | '/staff/projects'
    | '/staff/run-types'
    | '/staff/runs'
    | '/projects/$projectId/analyses/$analysisId'
    | '/projects/$projectId/reports/$reportId'
    | '/projects/$projectId/upload/$objectId'
    | '/staff/projects/$projectId/boundary'
    | '/staff/projects/$projectId/boundary/$objectId'
  id:
    | '__root__'
    | '/_client'
    | '/_staff'
    | '/login'
    | '/reset-password'
    | '/_client/assistant-access'
    | '/_client/organization'
    | '/oauth/consent'
    | '/r/$secret'
    | '/_client/'
    | '/_client/projects/$projectId'
    | '/_staff/staff/audit'
    | '/_staff/staff/ops'
    | '/_staff/staff/search'
    | '/_staff/staff/slack'
    | '/reset-password_/$uid/$token'
    | '/_staff/staff/'
    | '/_staff/staff/analyses/$analysisId'
    | '/_staff/staff/analysis-types/$key'
    | '/_staff/staff/missions/$missionId'
    | '/_staff/staff/missions/new'
    | '/_staff/staff/objects/$objectId'
    | '/_staff/staff/organizations/$orgId'
    | '/_staff/staff/projects/$projectId'
    | '/_staff/staff/reports/$reportId'
    | '/_staff/staff/runs/$runId'
    | '/_staff/staff/analysis-types/'
    | '/_staff/staff/missions/'
    | '/_staff/staff/organizations/'
    | '/_staff/staff/projects/'
    | '/_staff/staff/run-types/'
    | '/_staff/staff/runs/'
    | '/_client/projects_/$projectId/analyses/$analysisId'
    | '/_client/projects_/$projectId/reports/$reportId'
    | '/_client/projects_/$projectId/upload/$objectId'
    | '/_staff/staff/projects_/$projectId/boundary'
    | '/_staff/staff/projects_/$projectId/boundary_/$objectId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ClientRoute: typeof ClientRouteWithChildren
  StaffRoute: typeof StaffRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  OauthConsentRoute: typeof OauthConsentRoute
  RSecretRoute: typeof RSecretRoute
  ResetPasswordUidTokenRoute: typeof ResetPasswordUidTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_client': {
      id: '/_client'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff': {
      id: '/_staff'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_client/': {
      id: '/_client/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ClientIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/assistant-access': {
      id: '/_client/assistant-access'
      path: '/assistant-access'
      fullPath: '/assistant-access'
      preLoaderRoute: typeof ClientAssistantAccessRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/organization': {
      id: '/_client/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof ClientOrganizationRouteImport
      parentRoute: typeof ClientRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$secret': {
      id: '/r/$secret'
      path: '/r/$secret'
      fullPath: '/r/$secret'
      preLoaderRoute: typeof RSecretRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_client/projects/$projectId': {
      id: '/_client/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ClientProjectsProjectIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_staff/staff/': {
      id: '/_staff/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof StaffStaffIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/audit': {
      id: '/_staff/staff/audit'
      path: '/staff/audit'
      fullPath: '/staff/audit'
      preLoaderRoute: typeof StaffStaffAuditRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/ops': {
      id: '/_staff/staff/ops'
      path: '/staff/ops'
      fullPath: '/staff/ops'
      preLoaderRoute: typeof StaffStaffOpsRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/search': {
      id: '/_staff/staff/search'
      path: '/staff/search'
      fullPath: '/staff/search'
      preLoaderRoute: typeof StaffStaffSearchRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/slack': {
      id: '/_staff/staff/slack'
      path: '/staff/slack'
      fullPath: '/staff/slack'
      preLoaderRoute: typeof StaffStaffSlackRouteImport
      parentRoute: typeof StaffRoute
    }
    '/reset-password_/$uid/$token': {
      id: '/reset-password_/$uid/$token'
      path: '/reset-password/$uid/$token'
      fullPath: '/reset-password/$uid/$token'
      preLoaderRoute: typeof ResetPasswordUidTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff/staff/analyses/$analysisId': {
      id: '/_staff/staff/analyses/$analysisId'
      path: '/staff/analyses/$analysisId'
      fullPath: '/staff/analyses/$analysisId'
      preLoaderRoute: typeof StaffStaffAnalysesAnalysisIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/analysis-types/': {
      id: '/_staff/staff/analysis-types/'
      path: '/staff/analysis-types'
      fullPath: '/staff/analysis-types/'
      preLoaderRoute: typeof StaffStaffAnalysisTypesIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/analysis-types/$key': {
      id: '/_staff/staff/analysis-types/$key'
      path: '/staff/analysis-types/$key'
      fullPath: '/staff/analysis-types/$key'
      preLoaderRoute: typeof StaffStaffAnalysisTypesKeyRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/missions/': {
      id: '/_staff/staff/missions/'
      path: '/staff/missions'
      fullPath: '/staff/missions/'
      preLoaderRoute: typeof StaffStaffMissionsIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/missions/$missionId': {
      id: '/_staff/staff/missions/$missionId'
      path: '/staff/missions/$missionId'
      fullPath: '/staff/missions/$missionId'
      preLoaderRoute: typeof StaffStaffMissionsMissionIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/missions/new': {
      id: '/_staff/staff/missions/new'
      path: '/staff/missions/new'
      fullPath: '/staff/missions/new'
      preLoaderRoute: typeof StaffStaffMissionsNewRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/objects/$objectId': {
      id: '/_staff/staff/objects/$objectId'
      path: '/staff/objects/$objectId'
      fullPath: '/staff/objects/$objectId'
      preLoaderRoute: typeof StaffStaffObjectsObjectIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/organizations/': {
      id: '/_staff/staff/organizations/'
      path: '/staff/organizations'
      fullPath: '/staff/organizations/'
      preLoaderRoute: typeof StaffStaffOrganizationsIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/organizations/$orgId': {
      id: '/_staff/staff/organizations/$orgId'
      path: '/staff/organizations/$orgId'
      fullPath: '/staff/organizations/$orgId'
      preLoaderRoute: typeof StaffStaffOrganizationsOrgIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/projects/': {
      id: '/_staff/staff/projects/'
      path: '/staff/projects'
      fullPath: '/staff/projects/'
      preLoaderRoute: typeof StaffStaffProjectsIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/projects/$projectId': {
      id: '/_staff/staff/projects/$projectId'
      path: '/staff/projects/$projectId'
      fullPath: '/staff/projects/$projectId'
      preLoaderRoute: typeof StaffStaffProjectsProjectIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/reports/$reportId': {
      id: '/_staff/staff/reports/$reportId'
      path: '/staff/reports/$reportId'
      fullPath: '/staff/reports/$reportId'
      preLoaderRoute: typeof StaffStaffReportsReportIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/run-types/': {
      id: '/_staff/staff/run-types/'
      path: '/staff/run-types'
      fullPath: '/staff/run-types/'
      preLoaderRoute: typeof StaffStaffRunTypesIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/runs/': {
      id: '/_staff/staff/runs/'
      path: '/staff/runs'
      fullPath: '/staff/runs/'
      preLoaderRoute: typeof StaffStaffRunsIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/runs/$runId': {
      id: '/_staff/staff/runs/$runId'
      path: '/staff/runs/$runId'
      fullPath: '/staff/runs/$runId'
      preLoaderRoute: typeof StaffStaffRunsRunIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_client/projects_/$projectId/analyses/$analysisId': {
      id: '/_client/projects_/$projectId/analyses/$analysisId'
      path: '/projects/$projectId/analyses/$analysisId'
      fullPath: '/projects/$projectId/analyses/$analysisId'
      preLoaderRoute: typeof ClientProjectsProjectIdAnalysesAnalysisIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/projects_/$projectId/reports/$reportId': {
      id: '/_client/projects_/$projectId/reports/$reportId'
      path: '/projects/$projectId/reports/$reportId'
      fullPath: '/projects/$projectId/reports/$reportId'
      preLoaderRoute: typeof ClientProjectsProjectIdReportsReportIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/projects_/$projectId/upload/$objectId': {
      id: '/_client/projects_/$projectId/upload/$objectId'
      path: '/projects/$projectId/upload/$objectId'
      fullPath: '/projects/$projectId/upload/$objectId'
      preLoaderRoute: typeof ClientProjectsProjectIdUploadObjectIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_staff/staff/projects_/$projectId/boundary': {
      id: '/_staff/staff/projects_/$projectId/boundary'
      path: '/staff/projects/$projectId/boundary'
      fullPath: '/staff/projects/$projectId/boundary'
      preLoaderRoute: typeof StaffStaffProjectsProjectIdBoundaryRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff/staff/projects_/$projectId/boundary_/$objectId': {
      id: '/_staff/staff/projects_/$projectId/boundary_/$objectId'
      path: '/staff/projects/$projectId/boundary/$objectId'
      fullPath: '/staff/projects/$projectId/boundary/$objectId'
      preLoaderRoute: typeof StaffStaffProjectsProjectIdBoundaryObjectIdRouteImport
      parentRoute: typeof StaffRoute
    }
  }
}

interface ClientRouteChildren {
  ClientAssistantAccessRoute: typeof ClientAssistantAccessRoute
  ClientOrganizationRoute: typeof ClientOrganizationRoute
  ClientIndexRoute: typeof ClientIndexRoute
  ClientProjectsProjectIdRoute: typeof ClientProjectsProjectIdRoute
  ClientProjectsProjectIdAnalysesAnalysisIdRoute: typeof ClientProjectsProjectIdAnalysesAnalysisIdRoute
  ClientProjectsProjectIdReportsReportIdRoute: typeof ClientProjectsProjectIdReportsReportIdRoute
  ClientProjectsProjectIdUploadObjectIdRoute: typeof ClientProjectsProjectIdUploadObjectIdRoute
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientAssistantAccessRoute: ClientAssistantAccessRoute,
  ClientOrganizationRoute: ClientOrganizationRoute,
  ClientIndexRoute: ClientIndexRoute,
  ClientProjectsProjectIdRoute: ClientProjectsProjectIdRoute,
  ClientProjectsProjectIdAnalysesAnalysisIdRoute:
    ClientProjectsProjectIdAnalysesAnalysisIdRoute,
  ClientProjectsProjectIdReportsReportIdRoute:
    ClientProjectsProjectIdReportsReportIdRoute,
  ClientProjectsProjectIdUploadObjectIdRoute:
    ClientProjectsProjectIdUploadObjectIdRoute,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

interface StaffRouteChildren {
  StaffStaffAuditRoute: typeof StaffStaffAuditRoute
  StaffStaffOpsRoute: typeof StaffStaffOpsRoute
  StaffStaffSearchRoute: typeof StaffStaffSearchRoute
  StaffStaffSlackRoute: typeof StaffStaffSlackRoute
  StaffStaffIndexRoute: typeof StaffStaffIndexRoute
  StaffStaffAnalysesAnalysisIdRoute: typeof StaffStaffAnalysesAnalysisIdRoute
  StaffStaffAnalysisTypesKeyRoute: typeof StaffStaffAnalysisTypesKeyRoute
  StaffStaffMissionsMissionIdRoute: typeof StaffStaffMissionsMissionIdRoute
  StaffStaffMissionsNewRoute: typeof StaffStaffMissionsNewRoute
  StaffStaffObjectsObjectIdRoute: typeof StaffStaffObjectsObjectIdRoute
  StaffStaffOrganizationsOrgIdRoute: typeof StaffStaffOrganizationsOrgIdRoute
  StaffStaffProjectsProjectIdRoute: typeof StaffStaffProjectsProjectIdRoute
  StaffStaffReportsReportIdRoute: typeof StaffStaffReportsReportIdRoute
  StaffStaffRunsRunIdRoute: typeof StaffStaffRunsRunIdRoute
  StaffStaffAnalysisTypesIndexRoute: typeof StaffStaffAnalysisTypesIndexRoute
  StaffStaffMissionsIndexRoute: typeof StaffStaffMissionsIndexRoute
  StaffStaffOrganizationsIndexRoute: typeof StaffStaffOrganizationsIndexRoute
  StaffStaffProjectsIndexRoute: typeof StaffStaffProjectsIndexRoute
  StaffStaffRunTypesIndexRoute: typeof StaffStaffRunTypesIndexRoute
  StaffStaffRunsIndexRoute: typeof StaffStaffRunsIndexRoute
  StaffStaffProjectsProjectIdBoundaryRoute: typeof StaffStaffProjectsProjectIdBoundaryRoute
  StaffStaffProjectsProjectIdBoundaryObjectIdRoute: typeof StaffStaffProjectsProjectIdBoundaryObjectIdRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffStaffAuditRoute: StaffStaffAuditRoute,
  StaffStaffOpsRoute: StaffStaffOpsRoute,
  StaffStaffSearchRoute: StaffStaffSearchRoute,
  StaffStaffSlackRoute: StaffStaffSlackRoute,
  StaffStaffIndexRoute: StaffStaffIndexRoute,
  StaffStaffAnalysesAnalysisIdRoute: StaffStaffAnalysesAnalysisIdRoute,
  StaffStaffAnalysisTypesKeyRoute: StaffStaffAnalysisTypesKeyRoute,
  StaffStaffMissionsMissionIdRoute: StaffStaffMissionsMissionIdRoute,
  StaffStaffMissionsNewRoute: StaffStaffMissionsNewRoute,
  StaffStaffObjectsObjectIdRoute: StaffStaffObjectsObjectIdRoute,
  StaffStaffOrganizationsOrgIdRoute: StaffStaffOrganizationsOrgIdRoute,
  StaffStaffProjectsProjectIdRoute: StaffStaffProjectsProjectIdRoute,
  StaffStaffReportsReportIdRoute: StaffStaffReportsReportIdRoute,
  StaffStaffRunsRunIdRoute: StaffStaffRunsRunIdRoute,
  StaffStaffAnalysisTypesIndexRoute: StaffStaffAnalysisTypesIndexRoute,
  StaffStaffMissionsIndexRoute: StaffStaffMissionsIndexRoute,
  StaffStaffOrganizationsIndexRoute: StaffStaffOrganizationsIndexRoute,
  StaffStaffProjectsIndexRoute: StaffStaffProjectsIndexRoute,
  StaffStaffRunTypesIndexRoute: StaffStaffRunTypesIndexRoute,
  StaffStaffRunsIndexRoute: StaffStaffRunsIndexRoute,
  StaffStaffProjectsProjectIdBoundaryRoute:
    StaffStaffProjectsProjectIdBoundaryRoute,
  StaffStaffProjectsProjectIdBoundaryObjectIdRoute:
    StaffStaffProjectsProjectIdBoundaryObjectIdRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ClientRoute: ClientRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  OauthConsentRoute: OauthConsentRoute,
  RSecretRoute: RSecretRoute,
  ResetPasswordUidTokenRoute: ResetPasswordUidTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
